/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-04 09:48:00
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-06 11:12:46
 * @FilePath: /dbrank_b/src/routes/cms/components/BrandComponent/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import BrandManage from './BrandManage';
import classNames from 'classnames';
import OfficialAccount from './OfficialAccount';
import BrandExport from './BrandExport';
import BrandInput from './BrandInput';
import { uniqueId } from 'lodash';

class BrandComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0,
      brandName: '',
      brandId: '',
      globalKey: 'init',

      tree: [],
      deepIndex: 0,
      index: 0,
    }
  }

  getTabList = () => {
    const { current, brandName, brandId, globalKey } = this.state;

    return [
      { tab: '品牌管理', component: <BrandManage key={`manage_${brandId}_${globalKey}`} brandId={brandId} brandName={brandName} /> },
      { tab: '品牌数据信息', component: <BrandExport key={`export_${globalKey}`} brandName={brandName} /> },
      { tab: '官方账号', component: <OfficialAccount key={`account_${globalKey}`}brandName={brandName} /> },
    ].reduce((acc, curr, index) => {
      acc[0].push((
        <div
          onClick={() => {
            this.setState({ current: index })
          }}
          className={classNames(
            s.tabHeaderTab,
            { [s.tabHeaderTabActive]: current === index },
          )}
          key={`tab_${index}`}>
          {curr.tab}
        </div>
      ));
      acc[1].push((
        <div
          key={`content_${index}`}
          style={{
            display: current === index ? 'block' : 'none'
          }}>
          {curr.component}
        </div>
      ))
      return acc;
    }, [[], []]);
  }

  /**
   * 获取企业信息
   * @param {String} name 
   */
  getBrandTree = data => {
    this.setState({
      brandId: data.id,
      brandName: data.name,
      globalKey: uniqueId(),
      current: 0,
    })
  }

  renderContent = () => {
    const [tabHeader, tabBody] = this.getTabList();

    return (
      <div className={s.tabWrapper}>
        <div className={s.tabHeader}>
          {tabHeader}
        </div>

        <div className={s.tabBody}>
          {tabBody}
        </div>
      </div>
    )
  }

  renderEmpty = () => {
    return (
      <div className={s.tabWrapper}>
        <div className={s.empty}>请选择你要查看的品牌</div>
      </div>
    )
  }

  render() {
    const { brandName, brandId } = this.state;

    return (
      <div className={s.container}>
        <h1>品牌管理</h1>

        <div className={s.content} style={{ justifyContent: 'space-between', marginBottom: 10, padding: 10 }}>
          <BrandInput value={brandName} onChange={this.getBrandTree} className={s.input} />
        </div>

        {brandId ? this.renderContent() : this.renderEmpty()}
      </div>
    )
  }
}

export default withStyles(s)(BrandComponent)



// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/index.js